import BrandColors from "../../../../styles/BrandColors";
const { JLLBrandColors } = BrandColors;
const { ComponentColors } = JLLBrandColors;
const { ScoreIndicators } = ComponentColors;

export default (theme) => ({
  textStyle: {
    fontSize: 18,
    fontWeight: 600,
  },
  textStyle1: {
    fontSize: 14,
    fontWeight: 300,
  },
  container: {
    color: "#404040d1",
    border: "1px solid #f3f3f3",
  },
  borderRight: {
    borderRight: "1px solid #f3f3f3",
  },
  borderBottom: {
    borderBottom: "1px solid #f3f3f3",
  },
  borderTop: {
    borderTop: "1px solid #f3f3f3",
  },
  scoreText: {
    fontSize: 14,
    fontWeight: 900,
    margin: 5,
  },
  scoreTextBlocked: {
    fontSize: 14,
    fontWeight: 900,
    color: ScoreIndicators.block,
    margin: 5,
  },
  scoreTextHigh: {
    fontSize: 14,
    fontWeight: 900,
    color: ScoreIndicators.high,
    margin: 5,
  },
  scoreTextMedium: {
    fontSize: 14,
    fontWeight: 900,
    color: ScoreIndicators.medium,
    margin: 5,
  },
  scoreTextLow: {
    fontSize: 14,
    fontWeight: 900,
    color: ScoreIndicators.low,
    margin: 5,
  },
  scoreTextNoScore: {
    fontSize: 14,
    fontWeight: 900,
    color: ScoreIndicators.noScore,
    margin: 5,
  },
  AMLCheck: {
    fontSize: 12,
    textDecoration: "underline",
    color: "#ff6900",
    cursor: "default",
  },
  expiredText: {
    fontSize: 9,
    fontWeight: 900,
    color: ScoreIndicators.high,
  },
});
